import { render, staticRenderFns } from "./chart-header.component.vue?vue&type=template&id=034de998"
import script from "./chart-header.component.vue?vue&type=script&lang=js"
export * from "./chart-header.component.vue?vue&type=script&lang=js"
import style0 from "./chart-header.component.vue?vue&type=style&index=0&id=034de998&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports